(function(){
  function init(root){
    if(root.dataset.khaReady)return;
    root.dataset.khaReady='true';
    var selector=root.querySelector('[data-kha-variant]');
    function update(){
      if(!selector)return;
      var option=selector.options[selector.selectedIndex];
      var available=option.dataset.available==='true';
      root.querySelectorAll('[data-kha-price]').forEach(function(el){el.textContent=option.dataset.price;});
      root.querySelectorAll('[data-kha-cart]').forEach(function(button){button.disabled=!available;button.textContent=available?root.dataset.add:root.dataset.sold;});
    }
    if(selector)selector.addEventListener('change',update);
    update();
  }
  function scan(scope){scope.querySelectorAll('[data-kha]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan(document);});else scan(document);
  if(!window.kmHaulAwayEvents){window.kmHaulAwayEvents=true;
    document.addEventListener('shopify:section:load',function(event){scan(event.target);});
    document.addEventListener('shopify:block:select',function(event){var target=event.target;if(target.tagName==='DETAILS')target.open=true;});
  }
})();
